import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import '../../util/i18n'
import isMobileView from '../../util/MobileView'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import EditNameDesktop from './EditNameDesktop'
import EditNameMobile from './EditNameMobile'
import {
  fetchUser, selectUserObject, selectUserCallStatus, updateUser
} from '../../features/user/userSlice'

export function EditName() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const profile = useSelector(selectUserObject)
  const status = useSelector(selectUserCallStatus)

  const [values, setValues] = useState({ firstName: '', lastName: '' })
  const [errors, setErrors] = useState({})

  const nameRegex = {
    /*eslint-disable*/
    // only punctuation allowed: hyphens, apostrophe, space
    firstName:/[!\"#\$%&\(\)\*\+,\.\/:;<=>\?@\[\\\]^_`{\|}~]/,
    lastName: /[!\"#\$%&\(\)\*\+,\.\/:;<=>\?@\[\\\]^_`{\|}~]/,
  }

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchUser())
    }
  }, [status, dispatch])

  useEffect(() => {
    if (profile) {
      setValues({
        firstName: profile.firstName || '',
        lastName: profile.lastName || '',
      })
    }
  }, [profile])

  const handleChange = (e) => {
    const { name, value } = e.target
    setValues((v) => ({ ...v, [name]: value }))
    if(name === 'firstName' || name === 'lastName') {
      const isNotValid = nameRegex[name].test(value) //if true, not valid
      setErrors((errs) => ({ ...errs, [name]: isNotValid }))
    } else {
      setErrors((errs) => ({ ...errs, [name]: false }))
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrs = {}
    if (!values.firstName) newErrs.firstName = true
    if (nameRegex.firstName.test(values.firstName)) newErrs.firstName = true 
    if (nameRegex.lastName.test(values.lastName)) newErrs.lastName = true

    if (Object.keys(newErrs).length) {
      setErrors(newErrs)
      return
    }

    dispatch(updateUser(values))
      .unwrap()
      .then(() => navigate('/account'))
  }

  const handleCancel = () => {
    navigate('/account')
  }

  return (
    <MarginWrapper>
      {isMobileView() ? (
        <EditNameMobile
          t={t}
          userCallStatus={status}
          values={values}
          errors={errors}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          onCancel={handleCancel}
          isSaving={status === 'loading'}
        />
      ) : (
        <EditNameDesktop
          t={t}
          userCallStatus={status}
          values={values}
          errors={errors}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          onCancel={handleCancel}
          isSaving={status === 'loading'}
        />
      )}
    </MarginWrapper>
  )
}
